import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { searchHistoryData } from "../../API/api";
import { bindActionCreators } from "redux";
import { Actions } from "../../Action";
import { getSearchedTime, replacepercentageSymbol } from "../../utils";
import { useNavigate } from "react-router-dom";
import Layout from "../../NewComponent/Layout/Layout";
import SelectComp from "../../NewComponent/Select/Select";
import { Spin, Empty } from "antd";
import PaginationComp from "../../NewComponent/Pagination/Pagination";

export default function HistoryPage() {
  const dispatch = useDispatch();
  const { historySearchData, updatePageNumberHistory ,  getSearchHistorySortFilterVal, HPloading,isExternalSearchAllowed } = bindActionCreators(
    Actions,
    dispatch
  );
  const historyState = useSelector((state) => state.searchHistory);

  const fetchSearchHistory = () => {
    HPloading(true);
    searchHistoryData(historyState.pageNo, historyState.sortFilterVal)
      .then((res) => {
        if (res===undefined) return;
          historySearchData(res);
      })
      .catch((err) => console.log(err));
  };

  let navigate = useNavigate();
  const routeChange = (question) => {
    isExternalSearchAllowed(false);
    let path = `/seekerHome/search/${encodeURIComponent(
      replacepercentageSymbol(question)
    )}/false`;
    encodeURIComponent(navigate(path));
  };

//   const fetchMoreData = () => {
//     setTimeout(() => {
//       let totalExpectedPages = Math.ceil(historyState.totalCount / 10);
//       let incomingPageNo = historyState.pageNo + 1;
//       if (incomingPageNo < totalExpectedPages) {
//         updatePageNumberHistory(parseInt(historyState.pageNo) + 1);
//       }
//     }, 100);
//   };

  useEffect(() => {
    fetchSearchHistory();
  }, [
    historyState.sortFilterVal,
    historyState.pageNo,
    historyState.reloadPage,
  ]);
let container = {
    width: "74%",
    margin: "auto",
    marginTop: "1%",
    marginBottom: "7%",
    border: '1px solid #E0E2E6',
    background:'#FFFFFF',
    borderRadius:'12px',
    boxShadow: '0px 4px 16px 0px #1018280F',
    padding:'28px'

  };
  let subContainer = {
    border: '1px solid #E0E2E6',
    background:'#FFFFFF',
    borderRadius:'12px',
    padding:'20px',
    marginBottom:'16px'

  };
  const options = [
    { value: "desc", label: "Asked (Newest)" },
    { value: "asc", label: "Asked (Oldest)" }
];
const onChangePageNo = (e)=>{
    updatePageNumberHistory(e-1);
}
const onChangeFilter=(e)=>{
getSearchHistorySortFilterVal(e);
updatePageNumberHistory(0);
}
  return (
    <>
    <Layout>
    <div style={container}>
    <div style={{display:'flex',justifyContent:'space-between',alignItems:'center'}}>
    <div style={{color:'#2A364A', fontSize:'18px',lineHeight:'24px',fontWeight:'400'}}>My Search History</div><SelectComp val={historyState.sortFilterVal} onChangeFunc={onChangeFilter} width={'180px'} size={'large'} isString={false} options={options} />
    </div>
    <div className="mt-4">
    {historyState.isLoading && (
        <Spin size="large" spinning={true}>
          <div style={{ height: "100px" }}></div>
        </Spin>
      )}
      {!historyState.isLoading && historyState.historyData.length ===0 && <Empty/>}
      {!historyState.isLoading && historyState.historyData.length >0 && historyState.historyData.map(data=>{
        return(
            <div style={subContainer}>
                <div className="mb-2" style={{color:'#2A364A', fontSize:'18px', lineHeight:'24px', fontWeight:'400'}}>{data.time}</div>
                {data.dat.length !== 0  && data.dat.map((str)=>{
                   return(
                    <div className="mt-3 mb-3" onClick={()=>routeChange(str.question)} style={{color:'#5C667B', fontSize:'16px', lineHeight:'22px', fontWeight:'300', cursor:'pointer'}}><span style={{fontWeight:'400', fontSize:'17px'}}>{getSearchedTime(str.timestamp).toLocaleString()}</span>&nbsp;&nbsp;{str.question}</div>
                   )
                })}
            </div>
        )
      }) }
    </div>
    <div style={{display:'flex',justifyContent:'end'}}>
    {!historyState.isLoading && <PaginationComp page={historyState.pageNo+1} total={historyState.totalCount} onChangeFunc={onChangePageNo} />}
    </div>
    </div>
    </Layout>
    </>
  );
}
